import { render, staticRenderFns } from "./addSmsAccount.vue?vue&type=template&id=38ff90d0"
import script from "./addSmsAccount.vue?vue&type=script&lang=ts"
export * from "./addSmsAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports